import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { ScreenName } from '@/navigation/types';

const isTesting = process.env.EXPO_PUBLIC_APP_ENV === 'test';

// Firebase config — use your public keys from .env or app.config
const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize once
let analyticsInstance: ReturnType<typeof getAnalytics> | null = null;

function initAnalytics() {
  if (!analyticsInstance) {
    const app = initializeApp(firebaseConfig);
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
}

export default function analytics() {
  if (isTesting) {
    return new Proxy(
      {},
      {
        get: () => async () => {},
      },
    );
  }
  const instance = initAnalytics();

  return {
    logScreenView: async ({
      screenName,
      screenClass,
    }: {
      screenName: ScreenName | string;
      screenClass?: string;
    }) => {
      logEvent(instance, 'screen_view' as string, {
        screen_name: screenName,
        screen_class: screenClass ?? 'ReactNativeScreen',
      });
    },
    setUserId: async (userId: string | null) => {
      setUserId(instance, userId);
    },
    setUserProperty: async (name: string, value: string) => {
      setUserProperties(instance, { [name]: value });
    },
    logEvent: async (name: string, params?: Record<string, unknown>) => {
      logEvent(instance, name, params);
    },
  };
}
